/* eslint-disable max-len */
import React from 'react';

const Premium: React.FC<object> = () => {

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20C12.6522 20 15.1957 18.9465 17.071 17.071C18.9465 15.1957 20 12.6522 20 10C20 7.34783 18.9465 4.8043 17.071 2.92894C15.1957 1.05357 12.6522 0 10 0C7.34783 0 4.8043 1.05357 2.92894 2.92894C1.05357 4.8043 0 7.34783 0 10C0 12.6522 1.05357 15.1957 2.92894 17.071C4.8043 18.9465 7.34783 20 10 20Z"
                fill="#FFE8A0"
            />
            <path
                d="M8.15168 15.2077C7.5791 15.2077 7.14209 14.7548 7.14209 14.1457V13.2964H6.67494C6.20778 13.2964 5.84613 12.9373 5.84613 12.4531C5.84613 11.969 6.20778 11.6098 6.67494 11.6098H7.14209V10.8192H6.67494C6.19272 10.8192 5.83105 10.4445 5.83105 9.92903C5.83105 9.41372 6.19272 9.03893 6.67494 9.03893H7.14209V5.85298C7.14209 5.24391 7.5791 4.79102 8.16678 4.79102H10.9546C12.8834 4.79102 14.1644 5.99354 14.1644 7.80513C14.1644 9.61674 12.8834 10.8192 10.9546 10.8192H9.17647V11.6098H11.1459C11.6281 11.6098 11.9748 11.969 11.9748 12.4531C11.9748 12.9373 11.6281 13.2964 11.1459 13.2964H9.17647V14.1457C9.17647 14.7548 8.73939 15.2077 8.15168 15.2077ZM9.17647 9.03893H10.819C11.6177 9.03893 12.13 8.57039 12.13 7.82075C12.13 7.07113 11.6177 6.57138 10.819 6.57138H9.17647V9.03893Z"
                fill="#383838"
            />
        </svg>
    );
};

export default Premium;